import t from 'tcomb-form';
import * as R from 'ramda';

export const Email = t.subtype(
    t.Str,
    function(s) {
        return /^\S+@\S+\.\S+$/.test(s);
    },
    'Email'
);
export const FullString = t.refinement(t.String, (s) => R.trim(s) !== '', 'FullString');
export const PhoneNumber = t.subtype(
    t.Str,
    function(s) {
        const onlyDigits = s.replace(/^\D$/gi);
        return onlyDigits.length > 7 && onlyDigits.length < 16;
    },
    'Phone Number'
);

export const Latitude = t.refinement(t.Number, (n) => n >= -90 && n <= 90);
export const Longitude = t.refinement(t.Number, (n) => n >= -180 && n <= 180);
export const IntIndex = t.refinement(
    t.Num,
    (num) => {
        if (num <= 0) return false;
        // make sure floor of num equals num
        if (num !== ~~num) return false;
        return true;
    },
    'IntIndex'
);



// WEBPACK FOOTER //
// ./tcomb_types.js